import { createSlice } from '@reduxjs/toolkit';

const devicesSlice = createSlice({
  name: 'devices',
  initialState: {
    selectedDevices: [],
  },
  reducers: {
    addDevice: (state, action) => {
      const { serialNumber, kind, name, deviceId } = action.payload;
      if (!state.selectedDevices.some(d => d.serialNumber === serialNumber)) {
        state.selectedDevices.push({ serialNumber, kind, name, deviceId});
      }
    },
    removeDevice: (state, action) => {
      const serialNumber = action.payload;
      state.selectedDevices = state.selectedDevices.filter(
        (device) => device.serialNumber !== serialNumber
      );
    },
    clearSelectedDevices: state => {
      state.selectedDevices = [];
    },
  },
});

export const { addDevice, removeDevice, clearSelectedDevices } = devicesSlice.actions;
export default devicesSlice.reducer;